export default "<p>\n  refresh-tooltip works!\n</p>\n"